export const Interes_item = [
    {
        'nombre': 'Cuadro General de Clasificación Archivística',
        'url':'../GeneralArchivistica',
        
    },

]